export default __webpack_public_path__ + "static/media/icon-Table-Active.7b955673.svg";